import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import DateFnsAdapter from '@date-io/date-fns'
import enGB from 'date-fns/locale/en-GB'
import { VDateInput } from 'vuetify/labs/VDateInput'
import { VStepperVertical, VStepperVerticalItem, VStepperVerticalActions } from 'vuetify/labs/VStepperVertical'

export default createVuetify({
  display: {
    mobileBreakpoint: 'sm',
  },
  components: {
    ...components,
    VDateInput,
    VStepperVertical,
    VStepperVerticalItem,
    VStepperVerticalActions
  },
  directives,
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        dark: false,
        colors: {
          primary: '#0d6546',
          'primary-darken-1': '#0a4d39',
          secondary: '#34bc78',
          'secondary-darken-1': '#0d6546',
          accent: '#9481df',
          error: '#b71c1c',
          info: '#bef4c0',
          background: '#ffffff',
          surface: '#ffffff',
        }
      },
    }
  },
  date: {
    adapter: DateFnsAdapter,
    locale: {
      en: enGB
    }
  }
})
